import React, { Component } from 'react';
import { Context } from 'context';

import equals from "fast-deep-equal";

import Folders from 'editor/sidebar/folders/Folders';

import styles from 'editor/sidebar/Sidebar.module.scss';
import Heading from "editor/sidebar/heading/Heading";
import Filters from "editor/sidebar/filters/Filters";
import Tabs from "editor/sidebar/tabs/Tabs";

class Sidebar extends Component {
    static contextType = Context;

    state = {
        tab: 0,
        search: ""
    }

    /**
     * Stops unnecessary rendering
     * @param nextProps
     * @param nextState
     * @param nextContext
     * @returns {boolean}
     */
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const folderStructureChanged = !equals(this.context.folderStructure, nextContext.folderStructure);
        const stateChanged = !equals(this.state, nextState);
        return folderStructureChanged || stateChanged;
    }

    /**
     * Set active sidebar (All Maps <-> Edited Maps)
     */
    setTab = tab => {
        this.setState({ tab })
    };

    /**
     * Set the current search term from the sidebar
     */
    setSearch = search => {
        this.setState({ search })
    }

    render() {
        return (
            <div className={`${styles.sidebar} highlightSecondary bgSecondary`}>
                <Heading/>
                <Filters
                    search={this.state.search}
                    setSearch={this.setSearch}
                />
                <Tabs
                    tab={this.state.tab}
                    setTab={this.setTab}
                />
                <Folders
                    tab={this.state.tab}
                    search={this.state.search}
                />
            </div>
        )        
    }
}

export default Sidebar;
